import React from 'react'
import PropTypes from 'prop-types'
import LineAwesome from 'react-line-awesome-svg/components/line-awesome'
import TimesSolid from 'react-line-awesome-svg/icons/TimesSolid'
import './styles.scss'

const FilterChips = ({
  filterChips,
  updateFilter,
  unremovableFields,
  unremovable,
}) => {
  const unremovables = [...['perimeter', 'location'], ...unremovableFields]

  const onChipRemove = field => {
    if (!unremovable && !unremovables.includes(field)) {
      updateFilter(field, null)
    }
  }

  if (!filterChips) {
    return
  }

  return (
    <div className={`dhsv_filter_chips${unremovable ? ' unremovable' : ''}`}>
      {Object.keys(filterChips).map(key => (
        <span
          key={key}
          onClick={() => onChipRemove(key)}
          className={unremovables.includes(key) ? 'unremovable' : ''}
        >
          {filterChips[key]}
          <LineAwesome icon={TimesSolid} fill="currentColor" />
        </span>
      ))}
    </div>
  )
}

FilterChips.propTypes = {
  filterChips: PropTypes.object,
  updateFilter: PropTypes.func,
  unremovableFields: PropTypes.array,
  unremovable: PropTypes.bool,
}

FilterChips.defaultProps = {
  unremovableFields: [],
}

export default FilterChips
